import type {PartialOptions} from "../../stem-core/ui/UIBase";
import {UI} from "../../stem-core/ui/UIBase";
import {StyleSheet, styleRule, registerStyle} from "../../stem-core/ui/Style";
import {Theme} from "../../stem-core/ui/style/Theme";
import type {UIChild} from "../../stem-core/ui/UIBase";

export class LineSeparatorStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 15,
    };

    @styleRule
    text = {
        padding: "0 8px",
        fontStyle: "italic",
        color: this.themeProps.DIVIDER_TEXT_COLOR,
    };

    @styleRule
    line = {
        minHeight: 1,
        width: "100%",
        flex: 1,
    };
}

interface LineSeparatorOptions {
    lineColor?: string;
    text?: UIChild;
}

@registerStyle(LineSeparatorStyle)
export class LineSeparator extends UI.Element<LineSeparatorOptions> {
    getDefaultOptions(): PartialOptions<LineSeparator> {
        return {
            ...super.getDefaultOptions(),
            lineColor: Theme.props.DIVIDER_LINE_COLOR,
            text: null,
        }
    }

    render() {
        const {styleSheet} = this;
        const {text, lineColor} = this.options;
        return [
            <div className={styleSheet.line} style={{background: lineColor}}/>,
            text ? <div className={styleSheet.text}>{text}</div> : null,
            <div className={styleSheet.line} style={{background: lineColor}}/>,
        ]
    }
}
